import { render, staticRenderFns } from "./ColoredIconDocument.vue?vue&type=template&id=2201a3ce&scoped=true"
import script from "./ColoredIconDocument.vue?vue&type=script&lang=js"
export * from "./ColoredIconDocument.vue?vue&type=script&lang=js"
import style0 from "./ColoredIconDocument.vue?vue&type=style&index=0&id=2201a3ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201a3ce",
  null
  
)

export default component.exports